import { Module } from "../../../../types/TenantInterfaces";
import QueryUtils from "../../../../utils/QueryUtils";
import Search from "../Search";

interface Props {
  simpleSearchValue?: string;
  clearSimpleSearch: () => void;
  query: any;
  currentModule: Module;
  setSimpleSearchQuery?: (q: any) => void;
  setSimpleSearchValue: (val: string) => void;
  isMobile: boolean;
  searchTime?: number;
}

const SharedSearch = ({
  clearSimpleSearch,
  query,
  currentModule,
  setSimpleSearchQuery,
  setSimpleSearchValue,
  isMobile,
  searchTime,
}: Props) => {
  return (
    <Search
      onChange={updateSimpleSearch}
      // onLoading={(loading) => {}}
      onClear={clearSimpleSearch}
      clearFilter={clearSimpleSearchFilters}
      alwaysOpen={true}
      block={isMobile}
      searchTime={searchTime}
    />
  );

  function updateSimpleSearch(value: string) {
    let newQuery = structuredClone(query);

    if (value === "") {
      if (setSimpleSearchQuery) {
        setSimpleSearchQuery(null);
      }
      setSimpleSearchValue(value);
      return;
    }

    if (value) {
      const finalQuery = QueryUtils.appendFilterToQuery({
        searchedValue: value,
        dataSource: currentModule,
        existingQuery: newQuery,
        filterIdentifier: null,
      });

      newQuery = finalQuery;
    }

    setSimpleSearchValue(value);

    if (setSimpleSearchQuery) {
      setSimpleSearchQuery(newQuery);
    }
  }

  function clearSimpleSearchFilters() {
    if (setSimpleSearchQuery) {
      setSimpleSearchQuery(null);
    }
  }
};

export default SharedSearch;
